var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "main-footer" }, [
      _vm._v("\n    Copyright © 2023 "),
      _c("strong", [_vm._v(_vm._s(_vm.appName))]),
      _vm._v(". All rights reserved.\n    "),
      _c(
        "div",
        { staticClass: "float-right d-none d-sm-inline-block" },
        [
          _vm._v("\n      Developed with\n      "),
          _c("b-icon", { attrs: { color: "red", icon: "heart-fill" } }),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "text-reset fw-bold",
              attrs: {
                href: "/#",
                target: "_blank",
                title: "PT. Nash Interaksi Semesta",
              },
            },
            [_vm._v("PT. Nash Interaksi Semesta")]
          ),
          _vm._v("\n      Powered by KJS MARI\n    "),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("script", {
      attrs: {
        async: "",
        src: "https://www.googletagmanager.com/gtag/js?id=G-LEL7R2KC8S",
      },
    }),
    _vm._v(" "),
    _c("script", [
      _vm._v(
        "\n    window.dataLayer = window.dataLayer || []\n\n    function gtag() {\n      dataLayer.push(arguments)\n    }\n\n    gtag('js', new Date())\n\n    gtag('config', 'G-LEL7R2KC8S')\n  "
      ),
    ]),
    _vm._v(" "),
    _c("script", { attrs: { type: "text/javascript" } }, [
      _vm._v(
        "\n    var Tawk_API = Tawk_API || {},\n      Tawk_LoadStart = new Date()\n    ;(function () {\n      var s1 = document.createElement('script'),\n        s0 = document.getElementsByTagName('script')[0]\n      s1.async = true\n      s1.src = 'https://embed.tawk.to/5f30a8375c885a1b7fb7a339/1h210m8e4'\n      s1.charset = 'UTF-8'\n      s1.setAttribute('crossorigin', '*')\n      s0.parentNode.insertBefore(s1, s0)\n    })()\n  "
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }